export const RECORD_REQUEST_CREATED = 'Record request created';
export const REQUEST_1_SENT = 'Request #1 sent';
export const REQUEST_2_SENT = 'Request #2 sent';
export const REQUEST_3_SENT = 'Request #3 sent';
export const RECORDS_UNAVAILABLE = 'Records unavailable';
export const RECORDS_RECEIVED = 'Records received';
export const NO_RESPONSE_FROM_CLINIC = 'No Response From Clinic';
export const RECEIPT_SENT = 'Receipt sent';
export const EMAIL_RECEIVED = 'Email received';
